export const sanitizeColumnId = (id: string) =>
  id.toLowerCase().replace(/\s+/g, '-')
